import { useApi } from '../api/useApi';
import Loader from './ui/Loader';
import SectionHeader from './ui/SectionHeader';
import TeamCarousel from './TeamCarousel';

export default function Team() {
  const { data: team, loading } = useApi('/team', 'team');

  return (
    <section className="section section--team" id="team">
      <div className="container">
        <SectionHeader
          eyebrow="Equipo"
          title="Profesionales comprometidos con tu caso"
          subtitle="Un equipo multidisciplinario con experiencia en distintas áreas del derecho."
        />

        {loading ? <Loader /> : <TeamCarousel members={team ?? []} />}
      </div>
    </section>
  );
}
